import { makeStyles } from '@material-ui/core/styles';

const fontSize = (value) => {
  const { innerHeight, innerWidth } = window;
  const percentage = parseInt( ( (((innerWidth * value) / 100) + ((innerHeight * value) / 100)) / 5), 10 );
  return Number.isNaN( percentage ) ? value : percentage;
};

export default makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  container: {
    border: 1,
    borderRadius: 5,
    borderWidth: 10,
    borderColor: 'black'
  },
  paper: {
    margin: 'auto',
  },
  boxInside: {
    flex: 1,
    flexDirection: 'column',
  },
  image: {
    width: 80,
    height: 80,
    borderRadius: 'inherit',
  },
  img: {
    margin: 'auto',
    display: 'flex',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  textGrid: {
    padding: 0,
  },
  titleLeft: {
    fontSize: fontSize(3.8),
    fontFamily: 'Quicksand',
    color: 'white',
  },
  descriptionLeft: {
    marginTop: 5,
    marginBottom: 5,
    fontSize: fontSize(3.4),
    fontFamily: 'inherit',
    color: 'white',
    overflowX: 'auto',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  },
  titleRight: {
    fontSize: fontSize(3.8),
    color: 'white',
  },
  descriptionRight: {
    marginTop: 5,
    marginBottom: 5,
    fontFamily:'Quicksand',
    fontSize: fontSize(3.4),
    color: 'white',
    overflowX: 'auto',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  },
  titleBackground: {
    fontSize: fontSize(4.5),
    color: 'white',
  },
  descriptionBackground: {
    marginTop: 0,
    fontSize: fontSize(5.4),
    color: 'white'
  },
  titleHeader: {
    fontSize: fontSize(4),
    fontFamily:'Quicksand',
    color: 'white',
  },
  descriptionHeader: {
    fontSize: fontSize(3.4),
    color: 'white',
    marginTop: 5,
    marginBottom: 5,
    overflowX: 'auto',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  },
  img_head:{
    margin: 'auto',
    display: 'flex',
    maxWidth: '100%',
    height: 'auto',
    marginLeft: 110,
  }
})
);
